export default __webpack_public_path__ + "ed9e384b4fc351899415772187ed3e1c.png";